import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.flags";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { ValidationProvider } from 'vee-validate';
import { ValidationMode } from "~/web-components/k5-form/src/enums/ValidationMode";

var FormBase = /*#__PURE__*/function (_Vue) {
  _inherits(FormBase, _Vue);

  var _super = _createSuper(FormBase);

  function FormBase() {
    var _this;

    _classCallCheck(this, FormBase);

    _this = _super.apply(this, arguments);
    _this.validated = false;
    _this.valid = false;
    return _this;
  }

  _createClass(FormBase, [{
    key: "showIsValid",
    value: function showIsValid() {
      if (!this.showValidationState || !this.$refs.validator) {
        return false;
      }

      return this.$refs.validator.flags.validated && this.$refs.validator.flags.valid;
    }
  }, {
    key: "showIsInvalid",
    value: function showIsInvalid() {
      if (!this.showValidationState || !this.$refs.validator) {
        return false;
      }

      return this.$refs.validator.flags.validated && this.$refs.validator.flags.invalid;
    }
  }, {
    key: "validateComponent",
    value: function () {
      var _validateComponent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var silent,
            _result,
            result,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                silent = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                this.validated = true;

                if (!(typeof this.$refs.validator.validate === 'function')) {
                  _context.next = 14;
                  break;
                }

                if (!silent) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this.$refs.validator.validateSilent();

              case 6:
                _result = _context.sent;
                this.valid = _result.valid;
                return _context.abrupt("return", _result.valid);

              case 9:
                _context.next = 11;
                return this.$refs.validator.validate();

              case 11:
                result = _context.sent;
                this.valid = result.valid;
                return _context.abrupt("return", result.valid);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validateComponent() {
        return _validateComponent.apply(this, arguments);
      }

      return validateComponent;
    }()
  }, {
    key: "reset",
    value: function reset() {
      if (typeof this.$refs.validator.reset === 'function') {
        this.$refs.validator.reset();
      }
    }
  }]);

  return FormBase;
}(Vue);

__decorate([PropSync('data')], FormBase.prototype, "value", void 0);

__decorate([Prop()], FormBase.prototype, "rules", void 0);

__decorate([Prop({
  default: false
})], FormBase.prototype, "skipIfEmpty", void 0);

__decorate([Prop({
  default: function _default() {
    return ValidationMode.Lazy;
  }
})], FormBase.prototype, "mode", void 0);

__decorate([Prop({
  default: false
})], FormBase.prototype, "disabled", void 0);

__decorate([Prop({
  default: true
})], FormBase.prototype, "large", void 0);

__decorate([Prop({
  default: true
})], FormBase.prototype, "showValidationState", void 0);

__decorate([Prop()], FormBase.prototype, "link", void 0);

__decorate([Prop()], FormBase.prototype, "linkText", void 0);

__decorate([Prop()], FormBase.prototype, "notice", void 0);

__decorate([Prop({
  default: ''
})], FormBase.prototype, "name", void 0);

FormBase = __decorate([Component({
  components: {
    ValidationProvider: ValidationProvider
  }
})], FormBase);
export default FormBase;